import { render } from "./ArchivePreview.vue?vue&type=template&id=1b5dd52d&scoped=true"
import script from "./ArchivePreview.vue?vue&type=script&lang=js"
export * from "./ArchivePreview.vue?vue&type=script&lang=js"

import "./ArchivePreview.vue?vue&type=style&index=0&id=1b5dd52d&lang=scss&scoped=true"

import exportComponent from "E:\\uni-app项目\\kxsns-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5dd52d"]])

export default __exports__